import { render, staticRenderFns } from "./SheXiangTouRenLianShiBie.vue?vue&type=template&id=187279d9&scoped=true&"
import script from "./SheXiangTouRenLianShiBie.vue?vue&type=script&lang=js&"
export * from "./SheXiangTouRenLianShiBie.vue?vue&type=script&lang=js&"
import style0 from "./SheXiangTouRenLianShiBie.vue?vue&type=style&index=0&id=187279d9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187279d9",
  null
  
)

export default component.exports